import Header from "../components/Header";

export default function Page({title, children}) {
    return (
        <div className="container-fluid">
            <Header title={title}/>
            { children }
        </div>
    )
}